import { Button as MuiButton, styled } from '@mui/material';

export const Button = styled(MuiButton)({
	height: '42px',
});
